import { render, staticRenderFns } from "./OrderStatusDeliveryBadge.vue?vue&type=template&id=4c7ed303"
import script from "./OrderStatusDeliveryBadge.vue?vue&type=script&lang=js"
export * from "./OrderStatusDeliveryBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports